import { DriverPreviousLicenceCheckDates } from "../../../../models/api/admin/driver";
import { StatusAction } from "../../../ActionableStatus/ActionableStatus";
import { LicenceChecksActions } from "../licenceCheckActions";
import LicenceCheckStatus from "../LicenceCheckStatus";

type FailedLicenceCheckStatusProps = {
    driverId: string;
    isManual: boolean;
    lastCheckDate: string;
    nextCheckDate: string;
    previousLicenceCheckDates: DriverPreviousLicenceCheckDates;
    failureReason: string;
    buildActions: (actionNames: LicenceChecksActions[]) => StatusAction[];
};

const FailedLicenceCheckStatus = ({
    driverId,
    isManual,
    lastCheckDate,
    nextCheckDate,
    previousLicenceCheckDates,
    failureReason,
    buildActions,
}: FailedLicenceCheckStatusProps) => {
    const actions = buildActions(
        isManual
            ? [
                  "editCheckDate",
                  "markAsChecked",
                  "markAsPending",
                  "disableFurtherChecks",
                  "changeToAutomatic",
              ]
            : [
                  "editCheckDate",
                  "retryCheck",
                  "changeToManual",
                  "disableFurtherChecks",
                  "previousLicenceCheckDates",
              ]
    );

    return (
        <LicenceCheckStatus
            previousLicenceCheckDates={previousLicenceCheckDates}
            actions={actions}
            theme="dvlaError"
            text="Failed"
            driverId={driverId}
            isManual={isManual}
        >
            <span>Last check: {lastCheckDate}</span>
            <span>Failed: {failureReason}</span>
            <span>Next check: {nextCheckDate}</span>
        </LicenceCheckStatus>
    );
};

export default FailedLicenceCheckStatus;
